import { createSelector } from '@reduxjs/toolkit';

import { COLLECTION_IDS } from '@/constants/collections';
import parametersSelector from '@/features/choice/selectors/parameters';
import configSelector from '@/features/config/selectors/config';

const carsParametersSelector = createSelector(
  [configSelector, parametersSelector],
  (config, parameters) => {
    const { spaceId, envId } = config;
    return {
      spaceId,
      envId,
      collectionId: COLLECTION_IDS.vehiclesVehicles,
      ...parameters,
    };
  },
);

export default carsParametersSelector;
